import { Lock01 } from "@untitledui/icons";

interface AccessDeniedNoticeProps {
    /** Explanation shown to the user (e.g. the "no permission" message). */
    message: string;
    /** Seconds left before the redirect, or null until the countdown starts. */
    secondsRemaining: number | null;
}

/**
 * Access-denied notice rendered in the content area, with a live countdown
 * before the app redirects the user to the login screen.
 */
export function AccessDeniedNotice({ message, secondsRemaining }: AccessDeniedNoticeProps) {
    const unit = secondsRemaining === 1 ? "second" : "seconds";

    return (
        <div role="alert" className="flex min-h-[60vh] flex-col items-center justify-center p-4 text-center">
            <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-gray-100">
                <Lock01 className="h-7 w-7 text-gray-500" aria-hidden="true" />
            </div>
            <p className="text-sm font-semibold text-brand-600">403</p>
            <h1 className="mt-1 text-2xl font-semibold text-gray-900">Access denied</h1>
            <p className="mt-2 max-w-md text-md text-gray-600">{message}</p>
            {secondsRemaining !== null && (
                <p className="mt-4 text-sm text-gray-500" aria-live="polite">
                    You will be redirected to the login screen in {secondsRemaining} {unit}.
                </p>
            )}
        </div>
    );
}
